import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "createEditSkillModal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content p-5" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = {
  class: "modal-title",
  id: "create-edit-skill-modal-label"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "w-100 d-flex flex-column" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Skill name", -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = {
  key: 0,
  class: "w-100 d-flex flex-column"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Parent skill", -1)
const _hoisted_14 = { class: "w-100" }
const _hoisted_15 = { class: "form-check mt-3 mt-xxl-0" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "cursor-pointer form-label text-nowrap",
  for: "greenSkillCheck"
}, "Green Skill", -1)
const _hoisted_18 = { class: "w-100 d-flex flex-column" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "workerDescription",
  class: "form-label"
}, "Worker Description", -1)
const _hoisted_20 = { class: "w-100 d-flex flex-column" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "clientDescription",
  class: "form-label"
}, "Client Description", -1)
const _hoisted_22 = { class: "w-100 d-flex flex-column" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Document type needed", -1)
const _hoisted_24 = {
  key: 1,
  class: "w-100 d-flex flex-column"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Dresscode", -1)
const _hoisted_26 = { class: "modal-footer flex-center" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "d-flex flex-column form gap-4",
          ref: "formComponent",
          "validation-schema": _ctx.validationSchema,
          onSubmit: _ctx.handleSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.modalTitle), 1),
              _createElementVNode("div", {
                class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false, null)))
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Enter skill name",
                name: "name"
              }),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ErrorMessage, { name: "name" })
                ])
              ])
            ]),
            (
              (_ctx.skillData == null && _ctx.newSkillParent == null) ||
                (_ctx.skillData && _ctx.skillData.parent_id)
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    filterable: "",
                    clearable: "",
                    modelValue: _ctx.fieldParentId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fieldParentId) = $event)),
                    size: "large",
                    placeholder: "Select Document Type",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: "greenSkillCheck",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.greenSkill) = $event)),
                    checked: _ctx.greenSkill
                  }, null, 8, _hoisted_16), [
                    [_vModelCheckbox, _ctx.greenSkill]
                  ]),
                  _createVNode(_component_el_tooltip, {
                    content: "'Green skills' are skills that a worker can apply for even if he does not have them.",
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_Field, { name: "worker_description" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("textarea", _mergeProps(field, {
                    name: "worker_description",
                    class: "form-control mb-3 fs-4",
                    id: "workerDescription",
                    rows: "3"
                  }), null, 16)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_Field, { name: "company_description" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("textarea", _mergeProps(field, {
                    name: "company_description",
                    class: "form-control mb-3 fs-4",
                    id: "clientDescription",
                    rows: "3"
                  }), null, 16)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_el_select, {
                filterable: "",
                clearable: "",
                modelValue: _ctx.documentType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.documentType) = $event)),
                size: "large",
                placeholder: "Select Document Type",
                class: "w-100"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypes, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.skillData && _ctx.skillData.parent_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_select, {
                    filterable: "",
                    modelValue: _ctx.dresscode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dresscode) = $event)),
                    clearable: "",
                    size: "large",
                    placeholder: "Select Dresscode",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dresscodes, (dresscode) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: dresscode.id,
                          label: dresscode.name,
                          value: dresscode.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "reset",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleModal(false, null))),
                class: "btn btn-white me-3"
              }, " Discard "),
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.loading,
                class: "btn btn-primary"
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                  : _createCommentVNode("", true),
                _hoisted_29
              ], 8, _hoisted_27)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "onSubmit"])
      ])
    ])
  ]))
}